import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-start justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_3 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_4 = { class: "sm:flex sm:items-start w-full" }
const _hoisted_5 = { class: "mt-3 text-center sm:mt-0 sm:text-left w-full" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { class: "text-sm text-gray-500" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogPanel = _resolveComponent("DialogPanel")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    as: "template",
    show: _ctx.open
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        class: "relative z-50",
        onClose: _ctx.close
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TransitionChild, {
            as: "template",
            enter: "ease-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-200",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
            ])),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogPanel, { class: "relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_DialogTitle, {
                              as: "h3",
                              class: "text-base font-semibold text-gray-900"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('profile.portfolio_group_add_modal.title')), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('profile.portfolio_group_add_modal.description')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6",
                                placeholder: _ctx.$t('profile.portfolio_group_add_modal.placeholder'),
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event))
                              }, null, 8, _hoisted_9), [
                                [_vModelText, _ctx.title]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "mb-3 inline-flex w-full justify-center rounded-md bg-royal-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-royal-blue-600 sm:mb-0 sm:ml-3 sm:w-auto cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmAction && _ctx.confirmAction(...args)))
                        }, _toDisplayString(_ctx.$t('profile.portfolio_group_add_modal.add_button')), 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:w-auto cursor-pointer",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                          ref: "cancelButtonRef"
                        }, _toDisplayString(_ctx.$t('profile.portfolio_group_add_modal.cancel_button')), 513)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["show"]))
}